const splitRGBA = (string) => {
    let list = string.slice(5, string.length - 1)
    list = list.split(',').map((child) => Number(child.trim()))
    return {
        r: list[0],
        g: list[1],
        b: list[2],
        a: list[3]
    }
}
export default (customStyle) => {
    return [
        [{
            '@primary-color':
                customStyle?.['lessVariable']?.['@primary-color'] ?
                    splitRGBA(customStyle['lessVariable']['@primary-color']) :
                    {
                        r: 36,
                        g: 97,
                        b: 181,
                        a: 1
                    }
        }, 'Primary Color', 'lessVar'],
        [{
            '@secondary-color':
                customStyle?.['lessVariable']?.['@secondary-color'] ?
                    splitRGBA(customStyle['lessVariable']['@secondary-color']) :
                    {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    }
        }, 'Secondary Color', 'lessVar'],
        [{
            '@text-color':
                customStyle?.['lessVariable']?.['@text-color'] ?
                    splitRGBA(customStyle['lessVariable']['@text-color']) :
                    {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 1
                    }
        }, 'Text Color', 'lessVar'],
        [{
            '@modal-custom-bg':
                customStyle?.['lessVariable']?.['@modal-custom-bg'] ?
                    splitRGBA(customStyle['lessVariable']['@modal-custom-bg']) :
                    {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    }
        }, 'Modal Background Color', 'lessVar'],
        [{
            '@toolbar-background':
                customStyle?.['lessVariable']?.['@toolbar-background'] ?
                    splitRGBA(customStyle['lessVariable']['@toolbar-background']) :
                    {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    }
        }, 'Toolbar Background', 'lessVar'],
        [{
            '@body-background':
                customStyle?.['lessVariable']?.['@body-background'] ?
                    splitRGBA(customStyle['lessVariable']['@body-background']) :
                    {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    }
        }, 'Content Background Color', 'lessVar'],
        [{
            '@custom-toolbar-icon':
                customStyle?.['lessVariable']?.['@custom-toolbar-icon'] ?
                    splitRGBA(customStyle['lessVariable']['@custom-toolbar-icon']) :
                    {
                        r: 102,
                        g: 102,
                        b: 102,
                        a: 1
                    }
        }, 'Icon Color', 'lessVar'],
        [{
            '--selection-bg-color':
                customStyle?.['cssVariable']?.['--selection-bg-color'] ?
                    splitRGBA(customStyle['cssVariable']['--selection-bg-color']) :
                    {
                        r: 36,
                        g: 97,
                        b: 181,
                        a: 1
                    }
        }, 'Selection Color', 'cssVar'],
        [{
            '--selection-text-color':
                customStyle?.['cssVariable']?.['--selection-text-color'] ?
                    splitRGBA(customStyle['cssVariable']['--selection-text-color']) :
                    {
                        r: 255,
                        g: 255,
                        b: 255,
                        a: 1
                    }
        }, 'Selection Text Color', 'cssVar'],
        [{
            '--mark-background':
                customStyle?.['cssVariable']?.['--mark-background'] ?
                    splitRGBA(customStyle['cssVariable']['--mark-background']) :
                    {
                        r: 255,
                        g: 229,
                        b: 143,
                        a: 1
                    }
        }, 'Mark Color', 'cssVar']
    ]
}